import { render, staticRenderFns } from "./TopicSkeleton.vue?vue&type=template&id=ab67847c&lang=pug"
import script from "./TopicSkeleton.vue?vue&type=script&lang=js"
export * from "./TopicSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports